import { AccountComponent } from './account/account.component';
import { ActivitySundryDialogComponent } from '../activities/activity-sundry-dialog/activity-sundry-dialog.component';
import { BehaviorService } from '@_services/Behavior.service';
import { BusinessComponent } from './business/business.component';
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  OnDestroy,
  OnInit,
  ViewChild,
} from '@angular/core';
import { DatePipe, Location } from '@angular/common';
import { DefultsComponent } from './defaults/defaults.component';
import { DIALOG_WIDTH } from '@/app/_constant/dialog-width.constants';
import { ExchangeRatesComponent } from './exchange-rates/exchange-rates.component';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { FuseConfirmDialogComponent } from '@/app/Shared/confirm-dialog/confirm-dialog.component';
import { InterstRatesComponent } from './interst-rates/interst-rates.component';
import { LookupsComponent } from './lookups/lookups.component';
import { MainAPiServiceService } from '@_services/main-api-service.service';
import { MatDialogRef, MatDialog } from '@angular/material/dialog';
import { MatterRatesComponent } from './matter-rates/matter-rates.component';
import { NameComponent } from './name/name.component';
import { ReginoalSettingComponent } from './regional-setting/reginoal-setting.component';
import { Router, ActivatedRoute } from '@angular/router';
import { catchError, combineLatest, of, Subject, switchMap, takeUntil } from 'rxjs';
import { TemplatesComponent } from './templates/templates.component';
import { ToastrService } from 'ngx-toastr';
import { TrustComponent } from './trust/trust.component';
import $ from 'jquery';

@Component({
  selector: 'app-system-setting',
  templateUrl: './system-setting.component.html',
  styleUrls: ['./system-setting.component.scss'],
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SystemSettingComponent implements OnInit, OnDestroy {
  confirmDialogRef: MatDialogRef<any>;
  errorWarningData: any = {};
  a: string;
  isLoadingResults: boolean = false;
  currentUSer: any = JSON.parse(localStorage.getItem('currentUser'));
  button: string;
  ForDataBind: any;
  public abc: any = {};
  SetAccountArray: any = [];
  SetAccountArray1: any = [];
  silqPayDrop: any = [];
  searchProvider: any = [];
  searchGstHanal: any = [];
  SettingForm: FormGroup;
  view: any;
  accountDialoge: any = [];
  texVal: any = [];
  clicked: any;
  isspiner: boolean = false;
  clickedBtn: string;
  accessTierPermission: any = JSON.parse(localStorage.getItem('set_tier_permission'));
  StoreName: any;
  appPermissions: any = JSON.parse(localStorage.getItem('app_permissions'));

  @ViewChild(NameComponent, { static: false }) NameChild: NameComponent;
  @ViewChild(BusinessComponent, { static: false })
  businessChild: BusinessComponent;
  @ViewChild(MatterRatesComponent, { static: false })
  MatterRatesChild: MatterRatesComponent;
  @ViewChild(DefultsComponent, { static: false })
  DefultsChild: DefultsComponent;
  @ViewChild(ReginoalSettingComponent, { static: false })
  ReginoalSettingChild: ReginoalSettingComponent;
  @ViewChild(TrustComponent, { static: false }) TrustChild: TrustComponent;
  @ViewChild(AccountComponent, { static: false })
  AccountChild: AccountComponent;
  @ViewChild(InterstRatesComponent, { static: false })
  InterstRatesChild: InterstRatesComponent;
  @ViewChild(ExchangeRatesComponent, { static: false })
  ExchangeRatesChild: ExchangeRatesComponent;
  @ViewChild(TemplatesComponent, { static: false })
  TemplatesChild: TemplatesComponent;
  @ViewChild(LookupsComponent, { static: false })
  LookupsChild: LookupsComponent;
  oldIsTrackId: string;
  isActivityData: string;
  DeletePostData: any;
  ApiMethod: any;
  refreshId: any;
  private _unsubscribeAll$: Subject<void> = new Subject();
  [x: string]: any;
  Deliverabledata: any;
  currentuser: any = JSON.parse(localStorage.getItem('currentUser'));

  constructor(
    private _mainAPiServiceService: MainAPiServiceService,
    public _matDialog: MatDialog,
    private toastr: ToastrService,
    private location: Location,
    public router: Router,
    private route: ActivatedRoute,
    private _formBuilder: FormBuilder,
    public behaviorService: BehaviorService,
    private cd: ChangeDetectorRef,
    public datepipe: DatePipe,
  ) {
    this.router.events.subscribe((val: any) => {
      this.appPermissions = JSON.parse(localStorage.getItem('app_permissions'));
      this.cd.markForCheck();
    });
    this.nameFunction();
    this.loading_fun();
    this.behaviorService.SysytemAccountData$.pipe(takeUntil(this._unsubscribeAll$)).subscribe(
      (result: any) => {
        if (result) {
          this.accountDialoge = result;
          this.cd.markForCheck();
        }
      },
    );
    this.behaviorService.APIretryCall$.pipe(takeUntil(this._unsubscribeAll$)).subscribe(
      (result: any) => {
        if (
          localStorage.getItem('istrackid') == 'SystemSettingNameComponent' &&
          result['click'] &&
          result['data']['GetSystem']
        ) {
          this.loadData();
          this.NameChild.ngOnInit();
        }
        if (
          localStorage.getItem('istrackid') == 'SystemSettingBusinessComponent' &&
          result['click'] &&
          result['data']['GetSystem']
        ) {
          this.loadData();
          this.businessChild.ngOnInit();
        }
        if (
          localStorage.getItem('istrackid') == 'SystemSettingMatterRatesComponent' &&
          result['click'] &&
          (result['data']['lookup'] || result['data']['user-rate'] || result['data']['GetSystem'])
        ) {
          this.loadData();
          this.MatterRatesChild.ngOnInit();
        }
        if (
          localStorage.getItem('istrackid') == 'SystemSettingDefultsComponent' &&
          result['click'] &&
          result['data']['GetSystem']
        ) {
          this.loadData();
          this.DefultsChild.ngOnInit();
        }
        if (
          localStorage.getItem('istrackid') == 'SystemSettingReginoalSettingComponent' &&
          result['click'] &&
          result['data']['GetSystem']
        ) {
          this.loadData();
          this.ReginoalSettingChild.ngOnInit();
        }
        if (
          localStorage.getItem('istrackid') == 'SystemSettingTrustComponent' &&
          result['click'] &&
          result['data']['GetSystem']
        ) {
          this.loadData();
          this.TrustChild.ngOnInit();
        }
        if (
          localStorage.getItem('istrackid') == 'SystemSettingAccountsComponent' &&
          result['click'] &&
          result['data']['GetSystem']
        ) {
          this.loadData();
          this.AccountChild.ngOnInit();
        }
        if (
          localStorage.getItem('istrackid') == 'SystemSettingInterstRatesComponent' &&
          result['click'] &&
          (result['data']['interest-rate'] || result['data']['GetSystem'])
        ) {
          this.loadData();
          this.InterstRatesChild.ngOnInit();
        }
        if (
          localStorage.getItem('istrackid') == 'SystemSettingExchangeRatesComponent' &&
          result['click'] &&
          (result['data']['exchange-rate'] || result['data']['GetSystem'])
        ) {
          this.loadData();
          this.ExchangeRatesChild.ngOnInit();
        }
        if (
          localStorage.getItem('istrackid') == 'SystemSettingTemplatesComponent' &&
          result['click'] &&
          result['data']['GetSystem']
        ) {
          this.loadData();
          this.TemplatesChild.ngOnInit();
        }
        if (
          localStorage.getItem('istrackid') == 'SystemSettingLookupsComponent' &&
          result['click'] &&
          (result['data']['lookup'] || result['data']['GetSystem'])
        ) {
          this.loadData();
          this.LookupsChild.ngOnInit();
        }
        this.cd.markForCheck();
      },
    );

    this.behaviorService.activitiesData$
      .pipe(takeUntil(this._unsubscribeAll$))
      .subscribe((result: any) => {
        if (result == null) {
          this.isActivityData = 'empty';
        } else {
          this.isActivityData = 'Notempty';
        }
        this.cd.markForCheck();
      });

    this.behaviorService.sendurlpath$
      .pipe(takeUntil(this._unsubscribeAll$))
      .subscribe((data: any) => {
        if (data != null) {
          if (data !== 'search-provider') {
            let capdata = data.charAt(0).toUpperCase() + data.slice(1);
            this.chnageUrlFunction(data, capdata);
          } else if (data == 'search-provider') {
            this.chnageUrlFunction('searchProvider', 'Searching Settings');
          }
          this.cd.markForCheck();
        }
      });
  }
  ngOnDestroy(): void {
    this._unsubscribeAll$.next();
    this._unsubscribeAll$.complete();
  }

  /**
   * It runs once after the component's view has been fully initialized.
   */
  ngOnInit() {
    this.SettingForm = this._formBuilder.group({
      SAMECOPYADDRESS: [''],
      CHAMBERS: [''],
      // for name
      BARRISTERSNAME: [''],
      ADDRESS1: [''],
      ADDRESS2: [''],
      SUBURB: [''],
      STATE: [''],
      POSTCODE: [''],
      POSTALADDRESS1: [''],
      POSTALADDRESS2: [''],
      POSTALSUBURB: [''],
      POSTALSTATE: [''],
      POSTALPOSTCODE: [''],
      DXNUMBER: [''],
      DXSUBURB: [''],
      PHONE1: [''],
      PHONE2: [''],
      FAX1: [''],
      FAX2: [''],
      EMAIL: [''],
      WWW: [''],
      FAMILYLAWCOURTID: [''],
      LRSBOXNUMBER: [''],
      //for busniness
      ABN: [''],
      GSTTYPE: [''],
      HOURLYBASERATE: ['', { updateOn: 'blur' }],
      DAILYBASERATE: ['', { updateOn: 'blur' }],
      HOURLYBASERATE2: ['', { updateOn: 'blur' }],
      DAILYBASERATE2: ['', { updateOn: 'blur' }],
      HOURLYBASERATE3: ['', { updateOn: 'blur' }],
      DAILYBASERATE3: ['', { updateOn: 'blur' }],
      HOURLYBASERATE4: ['', { updateOn: 'blur' }],
      DAILYBASERATE4: ['', { updateOn: 'blur' }],
      HOURLYBASERATE5: ['', { updateOn: 'blur' }],
      DAILYBASERATE5: ['', { updateOn: 'blur' }],
      HOURLYBASERATE6: ['', { updateOn: 'blur' }],
      DAILYBASERATE6: ['', { updateOn: 'blur' }],
      UNITSPERHOUR: [''],
      MATTERDELIVERABLEGUID: [''],
      DUEDATEOFFSET: [''],
      OFFICECHEQUEFORMAT: [''],
      VENDORISLIABLEFORSETTLEMENTDATE: [''],
      USESINGLELINEEXPENSE: [''],
      RATEOVERRIDESEQUENCE: [''],
      RATEDESCRIPTION1: [''],
      RATEDESCRIPTION2: [''],
      RATEDESCRIPTION3: [''],
      RATEDESCRIPTION4: [''],
      RATEDESCRIPTION5: [''],
      RATEDESCRIPTION6: [''],
      AUTOMATICNEWMATTERSUNDRY: [''],
      // for defults
      DEFAULTEXPENSETYPE: [''],
      DEFAULTPAIDTYPE: [''],
      DEFAULTINCOMETYPE: [''],
      SHORTNAMESTRATEGY: [''],
      REQUIRECOSTAGREEMENT: [''],
      DEFAULTMATTERCLASS: [''],
      REQUIREMATTEROWNER: [''],
      REQUIREFEEEARNER: [''],
      SUNDRYFEEEARNER: [''],
      SHOWCONFLICTCHECKFORNEWMATTER: [''],
      CHARGEDISBGSTONGSTFREEMATTERS: [''],
      ALLOWMOBILEACCESS: [''],
      DONTALLOWTRUSTOVERDRAWS: [''],
      REQUIREMATTERTYPE: [''],
      REQUIRECLIENTSOURCE: [''],
      REQUIREFIELDOFLAW: [''],
      REQUIREEXPENSEPAYEE: [''],
      //for estimate
      ESTIMATEWARNINGPERCENT: [''],
      ESTIMATENEXTTHRESHOLD: ['', { updateOn: 'blur' }],
      ESTIMATENEXTWARNINGPERCENT: [''],
      ALLOWESTIMATERANGE: [''],
      USEHIGHESTIMATEFORWARNING: [''],
      //for reginoal
      COUNTRY: [''],
      TAXTYPE: [''],
      TAXRATE: [''],
      CURRENCYSYMBOL: [''],
      TIMEZONE: [''],
      //for trust
      FIRSTTRUSTMONTH: [{ value: '', disabled: true }],
      TRUSTSTATE: [''],
      TRUSTCHEQUEFORMAT: [''],
      TRUSTRECEIPTCOPIES: [''],
      EFTTRUSTACCOUNTNAME: [''],
      EFTTRUSTBSB: [''],
      EFTTRUSTACCOUNTNUMBER: [''],
      DEFAULTTRUSTRECEIPTTYPE: [''],
      DEFAULTTRUSTWITHDRAWALTYPE: [''],
      TRUSTACCACCOUNTNAME: [''],
      TRUSTACCBSB: [''],
      TRUSTACCACCOUNTNUMBER: [''],
      TRUSTFIRSTWITHDRAWALCODE: [''],
      TRUSTFIRSTWITHDRAWALEFTID: [''],
      TRUSTFIRSTTRANSFERCODE: [''],
      TRUSTFIRSTRECEIPTCODE: [''],
      //for trmplate
      INVOICETEMPLATE: [''],
      RECEIPTTEMPLATE: [''],
      RECEIPTSAVEFOLDERLOCATION: [''],
      INVOICESAVEFOLDERPARENT: [''],
      RECEIPTSAVEFOLDERPARENT: [''],
      INVOICESAVEFOLDERLOCATION: [''],
      DONTGENERATERECEIPT: [''],
      DOCUMENTSYSTEM: [''],
      ROOTFOLDER: [''],
      SHAREPOINTDRIVE: [''],
      SIGNATUREUSERGUID: [''],
      NETDOCSCABINETNAME: [''],
      NETDOCSCLIENTATTRIBUTE: [''],
      NETDOCSMATTERATTRIBUTE: [''],
      // TEMPLATEFOLDER: [''],
      SHAREPOINTSUBSITE: [''],
      SHAREPOINTSITE: [''],
      DIRECTORYSAVESTRATEGY: [''],
      DOCUMENTSAVESTRATEGY: [''],
      DIRECTORYSAVESTATEGY: [''],
      DEFAULTSUBFOLDERS: [''],
      TRACKDOCUMENTS: [''],
      ONEDRIVEPRIMARYUSER: [''],
      // rates
      EFFECTIVEDATE: [''],
      sendEFFECTIVEDATE: [''],
      INTERESTRATE: [''],
      INTERESTGUID: [''],
      SCALE_: [''],
      CURRENCYID: [''],
      EXCHANGERATEGUID: [''],
      RATE: [''],
      //xero setting
      XEROINVOICEACCOUNT: [''],
      XERODONTSYNCEXPENSES: [''],
      XERODONTSYNCINVOICES: [''],
      XEROORGANISATION: [''],
      EMAILSYSTEM: [''],
      EMAILSAVEFOLDER: [''],
      EMAILATTACHMENTSAVEFOLDER: [''],
      EMAILSAVESTRATEGY: [''],
      //searching setting
      SEARCHPROVIDER: [''],
      SEARCHUSERNAME: [''],
      SEARCHPASSWORD: [''],
      SEARCHGSTHANDLING: [''],
      SEARCHURL: [''],
      SEARCHDOWNLOADUSERGUID: [''],
      //silq pay setting
      PINPAYMENTSAPIKEY: [''],
      PINPAYMENTSABSORBFEE: [''],
      SILQPAYLINKDESC: [''],
      SILQPAYSHOWINVDETAILS: [''],
      SILQPAYSHOWCHEQUEPAYMENT: [''],
      SILQPAYSHOWDDPAYMENT: [''],
      SILQPAYSHOWINVOICESTATEMENT1: [''],
      SILQPAYSHOWINVOICESTATEMENT2: [''],
      SILQPAYSHOWINVOICESTATEMENT3: [''],
      SILQPAYSHOWFEEAGRSTATEMENT: [''],
      SILQPAYSHOWGLOBALFOOTER: [''],

      //AML-CTF
      APLYIDKEY: [''],
      APLYIDSECRET: [''],
      //for statment
      STATEMENT2: [''],
      STATEMENT3: [''],
      STATEMENT4: [''],
      STATEMENT5: [''],
      STATEMENT2RTFBASE64: [''],
      STATEMENT3RTFBASE64: [''],
      STATEMENT4RTFBASE64: [''],
      STATEMENT2RTFFILE: [''],
      STATEMENT3RTFFILE: [''],
      STATEMENT4RTFFILE: [''],
      FEEAGREEMENTSTATEMENT: [''],
      STATEMENT2ISRTF: [''],
      STATEMENT3ISRTF: [''],
      STATEMENT4ISRTF: [''],
      XEROSTARTDATE: [''],
      XEROSTARTTEXTDATE: [''],
      //   practicve-account
      PRACACCACCOUNTNAME: [''],
      PRACACCBSB: [''],
      PRACACCACCOUNTNUMBER: [''],
      SWIFTID: [''],
      CLERKRATE: [''],

      IMANAGELIBRARYNAME: [''],
      DEFAULTUPLOADFOLDER: [''],
    });
    this.loadData();

    if (
      this.currentuser?.DELIVERABLES == null ||
      this.currentuser?.DELIVERABLES == 'null' ||
      this.currentuser?.DELIVERABLES == undefined ||
      this.currentuser?.DELIVERABLES == 'undefined'
    ) {
      this.SettingForm.controls['MATTERDELIVERABLEGUID'].setValue(
        this.DATA?.SYSTEM?.BUSINESSGROUP?.DELIVERABLES,
      );
      //this.editqueForm.get('MATTERDELIVERABLEGUID').setValue("No");
    } else {
      this.SettingForm.controls['MATTERDELIVERABLEGUID'].setValue(
        this.currentuser.DELIVERABLES.toString(),
      );
      //this.editqueForm.get('MATTERDELIVERABLEGUID').setValue(this.currentuser.DELIVERABLES);

      this.behaviorService.activitiesData$
        .pipe(takeUntil(this._unsubscribeAll$))
        .subscribe((result: any) => {
          if (result == null) {
            this.isActivityData = 'empty';
          } else {
            this.isActivityData = 'Notempty';
          }
          this.cd.markForCheck();
        });
    }

    this.behaviorService.appPermissionsSetting$
      .pipe(takeUntil(this._unsubscribeAll$))
      .subscribe((result: any) => {
        if (result) {
          this.appPermissions = JSON.parse(localStorage.getItem('app_permissions'));
          this.cd.markForCheck();
        }
      });
  }

  ngAfterViewInit() {
    //  this.cd.detectChanges();
  }

  /**
   * This function is used to click on the user activity
   */
  UserActivityClick() {
    // this.router.navigate(["/users/useractivity"]);

    this.behaviorService.loadingUserMenuResult(true);
    // this.location.replaceState("/users/useractivity");
    this.location.replaceState('/system-setting/users/useractivity');
    this.selUserMenuButton = 'UserActivity';

    setTimeout(() => {
      this.behaviorService.setUserMenuName('userActivity');
    }, 10);
    this.cd.detectChanges();
    this.isUsersUserActivity = true;
  }
  loadData() {
    // this.isLoadingResults = true;
    // this._mainAPiServiceService.getSetData({ EXCLUDESYSTEMACCOUNTS: true, EXCLUDEINVOICETEMPLATESETTINGS: true }, 'GetSystem').pipe(takeUntil(this._unsubscribeAll$)).subscribe(response => {
    //     if (response.CODE == 200 && response.STATUS == "success") {
    //         this.silqPayDrop = response.DATA.LISTS.PINPAYMENTSABSORBFEE;
    //         this.searchProvider = response.DATA.LISTS.SEARCHPROVIDER;
    //         this.searchGstHanal = response.DATA.LISTS.SEARCHGSTHANDLING;
    //         this.getVal(response);
    //         // this.isLoadingResults = false;
    //     }
    // }, error => {
    //     this.toastr.error(error);
    // });
  }
  /**
   * function is called to set the values to particular formgroup which is getting from API
   * @param data parameter for set the values of form fields
   */
  getVal(data: any) {
    // for trust
    this.behaviorService.SysytemAccountData(data.DATA.LISTS.SYSTEMACCOUNTS);
    // this.SettingForm.controls['DEFAULTTRUSTRECEIPTTYPE'].setValue(data.DATA.SYSTEM.TRUSTGROUP.DEFAULTTRUSTRECEIPTTYPE.toString());
    // this.SettingForm.controls['DEFAULTTRUSTWITHDRAWALTYPE'].setValue(data.DATA.SYSTEM.TRUSTGROUP.DEFAULTTRUSTWITHDRAWALTYPE.toString());
    // this.SettingForm.controls['EFTTRUSTACCOUNTNAME'].setValue(data.DATA.SYSTEM.TRUSTGROUP.EFTTRUSTACCOUNTNAME);
    // this.SettingForm.controls['EFTTRUSTACCOUNTNUMBER'].setValue(data.DATA.SYSTEM.TRUSTGROUP.EFTTRUSTACCOUNTNUMBER);
    // this.SettingForm.controls['EFTTRUSTBSB'].setValue(data.DATA.SYSTEM.TRUSTGROUP.EFTTRUSTBSB);
    // this.SettingForm.controls['TRUSTCHEQUEFORMAT'].setValue(data.DATA.SYSTEM.TRUSTGROUP.TRUSTCHEQUEFORMAT.toString());
    // this.SettingForm.controls['TRUSTRECEIPTCOPIES'].setValue(data.DATA.SYSTEM.TRUSTGROUP.TRUSTRECEIPTCOPIES.toString());
    // this.SettingForm.controls['TRUSTSTATE'].setValue(data.DATA.SYSTEM.TRUSTGROUP.TRUSTSTATE);
    // this.SettingForm.controls['FIRSTTRUSTMONTH'].setValue(data.DATA.SYSTEM.BUSINESSGROUP.FIRSTTRUSTMONTH.toString());

    //for name
    // let name = JSON.parse(localStorage.getItem('currentUser'));
    // name.UserName = data.DATA.SYSTEM.BARRISTERSNAME;
    // this.SettingForm.controls['BARRISTERSNAME'].setValue(data.DATA.SYSTEM.BARRISTERSNAME);
    // this.SettingForm.controls['FAMILYLAWCOURTID'].setValue(data.DATA.SYSTEM.FAMILYLAWCOURTID);
    // this.SettingForm.controls['LRSBOXNUMBER'].setValue(data.DATA.SYSTEM.LRSBOXNUMBER);
    // if (this.currentUSer.PRODUCTTYPE == 'Barrister') {
    //   this.SettingForm.controls['CHAMBERS'].setValue(data.DATA.SYSTEM.CHAMBERS);
    // }
    // this.SettingForm.controls['ADDRESS1'].setValue(data.DATA.SYSTEM.ADDRESSGROUP.STREETADDRESSGROUP.ADDRESS1);
    // this.SettingForm.controls['ADDRESS2'].setValue(data.DATA.SYSTEM.ADDRESSGROUP.STREETADDRESSGROUP.ADDRESS2);
    // this.SettingForm.controls['POSTCODE'].setValue(data.DATA.SYSTEM.ADDRESSGROUP.STREETADDRESSGROUP.POSTCODE);
    // this.SettingForm.controls['SUBURB'].setValue(data.DATA.SYSTEM.ADDRESSGROUP.STREETADDRESSGROUP.SUBURB);
    // this.SettingForm.controls['STATE'].setValue(data.DATA.SYSTEM.ADDRESSGROUP.STREETADDRESSGROUP.STATE_);

    // this.SettingForm.controls['POSTALADDRESS1'].setValue(data.DATA.SYSTEM.ADDRESSGROUP.POSTALADDRESSGROUP.POSTALADDRESS1);
    // this.SettingForm.controls['POSTALADDRESS2'].setValue(data.DATA.SYSTEM.ADDRESSGROUP.POSTALADDRESSGROUP.POSTALADDRESS2);
    // this.SettingForm.controls['POSTALPOSTCODE'].setValue(data.DATA.SYSTEM.ADDRESSGROUP.POSTALADDRESSGROUP.POSTALPOSTCODE);
    // this.SettingForm.controls['POSTALSUBURB'].setValue(data.DATA.SYSTEM.ADDRESSGROUP.POSTALADDRESSGROUP.POSTALSUBURB);
    // this.SettingForm.controls['POSTALSTATE'].setValue(data.DATA.SYSTEM.ADDRESSGROUP.POSTALADDRESSGROUP.POSTALSTATE);

    // this.SettingForm.controls['DXNUMBER'].setValue(data.DATA.SYSTEM.ADDRESSGROUP.DXGROUP.DXNUMBER);
    // this.SettingForm.controls['DXSUBURB'].setValue(data.DATA.SYSTEM.ADDRESSGROUP.DXGROUP.DXSUBURB);

    // this.SettingForm.controls['FAX1'].setValue(data.DATA.SYSTEM.CONTACTGROUP.FAX1);
    // this.SettingForm.controls['FAX2'].setValue(data.DATA.SYSTEM.CONTACTGROUP.FAX2);
    // this.SettingForm.controls['PHONE1'].setValue(data.DATA.SYSTEM.CONTACTGROUP.PHONE1);
    // this.SettingForm.controls['PHONE2'].setValue(data.DATA.SYSTEM.CONTACTGROUP.PHONE2);

    // this.SettingForm.controls['EMAIL'].setValue(data.DATA.SYSTEM.CONTACTGROUP.EMAIL);
    // this.SettingForm.controls['WWW'].setValue(data.DATA.SYSTEM.CONTACTGROUP.WWW);

    //for business

    // this.SettingForm.controls['ABN'].setValue(data.DATA.SYSTEM.BUSINESSGROUP.ABN);
    // this.SettingForm.controls['GSTTYPE'].setValue(data.DATA.SYSTEM.BUSINESSGROUP.GSTTYPE.toString());
    // this.SettingForm.controls['HOURLYBASERATE'].setValue(data.DATA.SYSTEM.BUSINESSGROUP.HOURLYBASERATE);
    // this.SettingForm.controls['DAILYBASERATE'].setValue(data.DATA.SYSTEM.BUSINESSGROUP.DAILYBASERATE);

    // this.SettingForm.controls['HOURLYBASERATE2'].setValue(data.DATA.SYSTEM.BUSINESSGROUP.HOURLYBASERATE2);
    // this.SettingForm.controls['DAILYBASERATE2'].setValue(data.DATA.SYSTEM.BUSINESSGROUP.DAILYBASERATE2);
    // this.SettingForm.controls['HOURLYBASERATE3'].setValue(data.DATA.SYSTEM.BUSINESSGROUP.HOURLYBASERATE3);
    // this.SettingForm.controls['DAILYBASERATE3'].setValue(data.DATA.SYSTEM.BUSINESSGROUP.DAILYBASERATE3);
    // this.SettingForm.controls['HOURLYBASERATE4'].setValue(data.DATA.SYSTEM.BUSINESSGROUP.HOURLYBASERATE4);
    // this.SettingForm.controls['DAILYBASERATE4'].setValue(data.DATA.SYSTEM.BUSINESSGROUP.DAILYBASERATE4);
    // this.SettingForm.controls['HOURLYBASERATE5'].setValue(data.DATA.SYSTEM.BUSINESSGROUP.HOURLYBASERATE5);
    // this.SettingForm.controls['DAILYBASERATE5'].setValue(data.DATA.SYSTEM.BUSINESSGROUP.DAILYBASERATE5);
    // this.SettingForm.controls['HOURLYBASERATE6'].setValue(data.DATA.SYSTEM.BUSINESSGROUP.HOURLYBASERATE6);
    // this.SettingForm.controls['DAILYBASERATE6'].setValue(data.DATA.SYSTEM.BUSINESSGROUP.DAILYBASERATE6);
    // this.SettingForm.controls['RATEDESCRIPTION1'].setValue(data.DATA.SYSTEM.BUSINESSGROUP.RATEDESCRIPTION1);
    // this.SettingForm.controls['RATEDESCRIPTION2'].setValue(data.DATA.SYSTEM.BUSINESSGROUP.RATEDESCRIPTION2);
    // this.SettingForm.controls['RATEDESCRIPTION3'].setValue(data.DATA.SYSTEM.BUSINESSGROUP.RATEDESCRIPTION3);
    // this.SettingForm.controls['RATEDESCRIPTION4'].setValue(data.DATA.SYSTEM.BUSINESSGROUP.RATEDESCRIPTION4);
    // this.SettingForm.controls['RATEDESCRIPTION5'].setValue(data.DATA.SYSTEM.BUSINESSGROUP.RATEDESCRIPTION5);
    // this.SettingForm.controls['RATEDESCRIPTION6'].setValue(data.DATA.SYSTEM.BUSINESSGROUP.RATEDESCRIPTION6);

    // this.SettingForm.controls['MATTERDELIVERABLEGUID'].setValue(data.DATA.SYSTEM.BUSINESSGROUP.DELIVERABLES);

    // this.SettingForm.controls['DELIVERABLES'].setValue(data.DATA.SYSTEM.BUSINESSGROUP.DELIVERABLES);
    // this.SettingForm.controls['UNITSPERHOUR'].setValue(data.DATA.SYSTEM.FEEEARNERS.UNITSPERHOUR.toString());
    // this.SettingForm.controls['DUEDATEOFFSET'].setValue(data.DATA.SYSTEM.INVOICEDEFAULTS.DUEDATEOFFSET);
    // this.SettingForm.controls['OFFICECHEQUEFORMAT'].setValue(data.DATA.SYSTEM.BUSINESSGROUP.OFFICECHEQUEFORMAT.toString());
    // this.SettingForm.controls['VENDORISLIABLEFORSETTLEMENTDATE'].setValue(data.DATA.SYSTEM.BUSINESSGROUP.VENDORISLIABLEFORSETTLEMENTDATE);
    // this.SettingForm.controls['USESINGLELINEEXPENSE'].setValue(data.DATA.SYSTEM.BUSINESSGROUP.USESINGLELINEEXPENSE);
    // this.SettingForm.controls['RATEOVERRIDESEQUENCE'].setValue(data.DATA.SYSTEM.BUSINESSGROUP.RATEOVERRIDESEQUENCE.toString());

    //for defults
    // this.SettingForm.controls['DEFAULTEXPENSETYPE'].setValue(data.DATA.SYSTEM.BUSINESSGROUP.DEFAULTEXPENSETYPE);
    // this.SettingForm.controls['DEFAULTPAIDTYPE'].setValue(data.DATA.SYSTEM.BUSINESSGROUP.DEFAULTPAIDTYPE.toString());
    // this.SettingForm.controls['DEFAULTINCOMETYPE'].setValue(data.DATA.SYSTEM.BUSINESSGROUP.DEFAULTINCOMETYPE);
    // this.SettingForm.controls['SHORTNAMESTRATEGY'].setValue(data.DATA.SYSTEM.BUSINESSGROUP.SHORTNAMESTRATEGY.toString());
    // this.SettingForm.controls['REQUIRECOSTAGREEMENT'].setValue(data.DATA.SYSTEM.BUSINESSGROUP.REQUIRECOSTAGREEMENT.toString());
    // this.SettingForm.controls['REQUIREMATTEROWNER'].setValue(data.DATA.SYSTEM.BUSINESSGROUP.REQUIREMATTEROWNER.toString());
    // this.SettingForm.controls['REQUIREFEEEARNER'].setValue(data.DATA.SYSTEM.BUSINESSGROUP.REQUIREFEEEARNER.toString());
    // this.SettingForm.controls['DEFAULTMATTERCLASS'].setValue(data.DATA.SYSTEM.BUSINESSGROUP.DEFAULTMATTERCLASS.toString());
    // this.SettingForm.controls['REQUIREMATTERTYPE'].setValue(data.DATA.SYSTEM.BUSINESSGROUP.REQUIREMATTERTYPE.toString());
    // this.SettingForm.controls['REQUIRECLIENTSOURCE'].setValue(data.DATA.SYSTEM.BUSINESSGROUP.REQUIRECLIENTSOURCE.toString());
    // this.SettingForm.controls['REQUIREFIELDOFLAW'].setValue(data.DATA.SYSTEM.BUSINESSGROUP.REQUIREFIELDOFLAW.toString());
    // this.SettingForm.controls['REQUIREEXPENSEPAYEE'].setValue(data.DATA.SYSTEM.BUSINESSGROUP.REQUIREEXPENSEPAYEE.toString());

    // this.SettingForm.controls['SUNDRYFEEEARNER'].setValue(data.DATA.SYSTEM.BUSINESSGROUP.SUNDRYFEEEARNER.toString());
    this.SettingForm.controls['ALLOWMOBILEACCESS'].setValue(
      data.DATA.SYSTEM.BUSINESSGROUP.ALLOWMOBILEACCESS,
    );
    // this.SettingForm.controls['SHOWCONFLICTCHECKFORNEWMATTER'].setValue(data.DATA.SYSTEM.BUSINESSGROUP.SHOWCONFLICTCHECKFORNEWMATTER);
    // this.SettingForm.controls['CHARGEDISBGSTONGSTFREEMATTERS'].setValue(data.DATA.SYSTEM.BUSINESSGROUP.CHARGEDISBGSTONGSTFREEMATTERS);

    this.SettingForm.controls['DONTALLOWTRUSTOVERDRAWS'].setValue(
      data.DATA.SYSTEM.BUSINESSGROUP.DONTALLOWTRUSTOVERDRAWS,
    );

    //for estimate
    // this.SettingForm.controls['ALLOWESTIMATERANGE'].setValue(data.DATA.SYSTEM.BUSINESSGROUP.ALLOWESTIMATERANGE);
    // this.SettingForm.controls['USEHIGHESTIMATEFORWARNING'].setValue(data.DATA.SYSTEM.BUSINESSGROUP.USEHIGHESTIMATEFORWARNING);
    // this.SettingForm.controls['ESTIMATEWARNINGPERCENT'].setValue(data.DATA.SYSTEM.BUSINESSGROUP.ESTIMATEWARNINGPERCENT);
    // this.SettingForm.controls['ESTIMATENEXTTHRESHOLD'].setValue(data.DATA.SYSTEM.BUSINESSGROUP.ESTIMATENEXTTHRESHOLD);
    // this.SettingForm.controls['ESTIMATENEXTWARNINGPERCENT'].setValue(data.DATA.SYSTEM.BUSINESSGROUP.ESTIMATENEXTWARNINGPERCENT);

    //reginoal setting
    // this.SettingForm.controls['COUNTRY'].setValue(data.DATA.SYSTEM.REGIONALGROUP.COUNTRY);
    // this.SettingForm.controls['CURRENCYSYMBOL'].setValue(data.DATA.SYSTEM.REGIONALGROUP.CURRENCYSYMBOL);
    // this.SettingForm.controls['TIMEZONE'].setValue(data.DATA.SYSTEM.REGIONALGROUP.TIMEZONE);
    // this.SettingForm.controls['TAXRATE'].setValue(data.DATA.SYSTEM.REGIONALGROUP.TAXRATE);
    // this.SettingForm.controls['TAXTYPE'].setValue(data.DATA.SYSTEM.REGIONALGROUP.TAXTYPE);

    //for Template
    // this.SettingForm.controls['INVOICETEMPLATE'].setValue(data.DATA.SYSTEM.INVOICEDEFAULTS.INVOICETEMPLATE);
    // this.SettingForm.controls['INVOICESAVEFOLDERLOCATION'].setValue(data.DATA.SYSTEM.INVOICEDEFAULTS.INVOICESAVEFOLDERLOCATION);
    // this.SettingForm.controls['RECEIPTSAVEFOLDERLOCATION'].setValue(data.DATA.SYSTEM.INVOICEDEFAULTS.RECEIPTSAVEFOLDERLOCATION);
    // this.SettingForm.controls['INVOICESAVEFOLDERPARENT'].setValue(data.DATA.SYSTEM.INVOICEDEFAULTS.INVOICESAVEFOLDERPARENT.toString());
    // this.SettingForm.controls['RECEIPTSAVEFOLDERPARENT'].setValue(data.DATA.SYSTEM.INVOICEDEFAULTS.RECEIPTSAVEFOLDERPARENT.toString());
    // this.SettingForm.controls['RECEIPTTEMPLATE'].setValue(data.DATA.SYSTEM.INVOICEDEFAULTS.RECEIPTTEMPLATE);
    // this.SettingForm.controls['DONTGENERATERECEIPT'].setValue(data.DATA.SYSTEM.INVOICEDEFAULTS.DONTGENERATERECEIPT);
    // this.SettingForm.controls['DEFAULTSUBFOLDERS'].setValue(data.DATA.SYSTEM.DOCUMENTGROUP.DEFAULTSUBFOLDERS);
    // this.SettingForm.controls['DIRECTORYSAVESTRATEGY'].setValue(data.DATA.SYSTEM.DOCUMENTGROUP.DIRECTORYSAVESTRATEGY.toString());
    // this.SettingForm.controls['DOCUMENTSYSTEM'].setValue(data.DATA.SYSTEM.DOCUMENTGROUP.DOCUMENTSYSTEM.toString());
    // this.SettingForm.controls['SHAREPOINTSITE'].setValue(data.DATA.SYSTEM.DOCUMENTGROUP.SHAREPOINTSITE.toString());
    // this.SettingForm.controls['SHAREPOINTSUBSITE'].setValue(data.DATA.SYSTEM.DOCUMENTGROUP.SHAREPOINTSUBSITE.toString());
    // this.SettingForm.controls['ROOTFOLDER'].setValue(data.DATA.SYSTEM.DOCUMENTGROUP.ROOTFOLDER.toString());
    // this.SettingForm.controls['SHAREPOINTDRIVE'].setValue(data.DATA.SYSTEM.DOCUMENTGROUP.SHAREPOINTDRIVE.toString());
    // this.SettingForm.controls['TEMPLATEFOLDER'].setValue(data.DATA.SYSTEM.DOCUMENTGROUP.TEMPLATEFOLDER.toString());
    // this.SettingForm.controls['DOCUMENTSAVESTRATEGY'].setValue(data.DATA.SYSTEM.DOCUMENTGROUP.DOCUMENTSAVESTRATEGY.toString());
    // this.SettingForm.controls['TRACKDOCUMENTS'].setValue(data.DATA.SYSTEM.DOCUMENTGROUP.TRACKDOCUMENTS);
    // this.SettingForm.controls['ONEDRIVEPRIMARYUSER'].setValue(data.DATA.SYSTEM.DOCUMENTGROUP.ONEDRIVEPRIMARYUSER);

    // this.SettingForm.controls['XEROSTARTDATE'].setValue(data.DATA.SYSTEM.XEROGROUP.XEROSTARTDATE);
    // let XEROStartDateArray = data.DATA.SYSTEM.XEROGROUP.XEROSTARTDATE.split("/");
    // this.SettingForm.controls['XEROSTARTTEXTDATE'].setValue(new Date(XEROStartDateArray[1] + '/' + XEROStartDateArray[0] + '/' + XEROStartDateArray[2]));

    this.SettingForm.patchValue({
      //xero setting
      // XEROINVOICEACCOUNT: data.DATA.SYSTEM.XEROGROUP.XEROINVOICEACCOUNT,
      // XERODONTSYNCEXPENSES: data.DATA.SYSTEM.XEROGROUP.XERODONTSYNCEXPENSES,
      // XERODONTSYNCINVOICES: data.DATA.SYSTEM.XEROGROUP.XERODONTSYNCINVOICES,
      // XEROORGANISATION: data.DATA.SYSTEM.XEROGROUP.XEROORGANISATION,
      //searching setting
      // SEARCHPROVIDER: (data.DATA.SYSTEM.SEARCHINGGROUP.SEARCHPROVIDER).toString(),
      // SEARCHDOWNLOADUSERGUID: data.DATA.SYSTEM.SEARCHINGGROUP.SEARCHDOWNLOADUSERGUID,
      // SEARCHUSERNAME: data.DATA.SYSTEM.SEARCHINGGROUP.SEARCHUSERNAME,
      // SEARCHPASSWORD: data.DATA.SYSTEM.SEARCHINGGROUP.SEARCHPASSWORD,
      // SEARCHGSTHANDLING: (data.DATA.SYSTEM.SEARCHINGGROUP.SEARCHGSTHANDLING).toString(),
      // SEARCHURL: data.DATA.SYSTEM.SEARCHINGGROUP.SEARCHURL,
      // Silq Pay
      // PINPAYMENTSAPIKEY: data.DATA.SYSTEM.SILQPAYGROUP.PINPAYMENTSAPIKEY,
      // PINPAYMENTSABSORBFEE: (data.DATA.SYSTEM.SILQPAYGROUP.PINPAYMENTSABSORBFEE).toString(),
      // SILQPAYLINKDESC: data.DATA.SYSTEM.SILQPAYGROUP.SILQPAYLINKDESC,
      // SILQPAYSHOWINVDETAILS: data.DATA.SYSTEM.SILQPAYGROUP.SILQPAYSHOWINVDETAILS,
      // SILQPAYSHOWCHEQUEPAYMENT: data.DATA.SYSTEM.SILQPAYGROUP.SILQPAYSHOWCHEQUEPAYMENT,
      // SILQPAYSHOWDDPAYMENT: data.DATA.SYSTEM.SILQPAYGROUP.SILQPAYSHOWDDPAYMENT,
      // SILQPAYSHOWINVOICESTATEMENT1: data.DATA.SYSTEM.SILQPAYGROUP.SILQPAYSHOWINVOICESTATEMENT1,
      // SILQPAYSHOWINVOICESTATEMENT2: data.DATA.SYSTEM.SILQPAYGROUP.SILQPAYSHOWINVOICESTATEMENT2,
      // SILQPAYSHOWINVOICESTATEMENT3: data.DATA.SYSTEM.SILQPAYGROUP.SILQPAYSHOWINVOICESTATEMENT3,
      // SILQPAYSHOWFEEAGRSTATEMENT: data.DATA.SYSTEM.SILQPAYGROUP.SILQPAYSHOWFEEAGRSTATEMENT,
      // SILQPAYSHOWGLOBALFOOTER: data.DATA.SYSTEM.SILQPAYGROUP.SILQPAYSHOWGLOBALFOOTER,
      // for statment settings
      // STATEMENT2: data.DATA.SYSTEM.STATEMENT2,
      // STATEMENT3: data.DATA.SYSTEM.STATEMENT3,
      // STATEMENT4: data.DATA.SYSTEM.STATEMENT4,
      // STATEMENT5: data.DATA.SYSTEM.STATEMENT5,
      // STATEMENT2RTFBASEB4:(data.DATA.SYSTEM.STATEMENT2RTFBASEB4),
      // STATEMENT3RTFBASEB4:(data.DATA.SYSTEM.STATEMENT3RTFBASEB4),
      // STATEMENT4RTFBASEB4:(data.DATA.SYSTEM.STATEMENT4RTFBASEB4),
      // STATEMENT2RTFFILE:(data.DATA.SYSTEM.STATEMENT2RTFFILE),
      // STATEMENT3RTFFILE:(data.DATA.SYSTEM.STATEMENT3RTFFILE),
      // STATEMENT4RTFFILE:(data.DATA.SYSTEM.STATEMENT4RTFFILE),
      // STATEMENT2ISRTF:(data.DATA.SYSTEM.STATEMENT2ISRTF),
      // STATEMENT3ISRTF:(data.DATA.SYSTEM.STATEMENT3ISRTF),
      // STATEMENT4ISRTF:(data.DATA.SYSTEM.STATEMENT4ISRTF),
      // FEEAGREEMENTSTATEMENT: data.DATA.SYSTEM.FEEAGREEMENTSTATEMENT,
    });
  }

  /**
   * This function is used to set the name
   */
  nameFunction() {
    if (this.router.url == '/system-setting/business') {
      this.ForDataBind = 'Business';
      this.clickedBtn = 'business';
    } else if (this.router.url == '/system-setting/name') {
      this.ForDataBind = 'Name';
      this.clickedBtn = 'name';
    } else if (this.router.url == '/system-setting/defaults') {
      this.ForDataBind = 'Defaults';
      this.clickedBtn = 'defaults';
    } else if (this.router.url == '/system-setting/estimates') {
      this.ForDataBind = 'Estimates';
      this.clickedBtn = 'estimate';
    } else if (this.router.url == '/system-setting/regional') {
      this.clickedBtn = 'regional';
      this.ForDataBind = 'Regional Settings';
    } else if (this.router.url == '/system-setting/trust') {
      this.ForDataBind = 'Trust';
      this.clickedBtn = 'trust';
    } else if (this.router.url == '/system-setting/templates') {
      this.ForDataBind = 'Templates';
      this.clickedBtn = 'templates';
    } else if (this.router.url == '/system-setting/account') {
      this.ForDataBind = 'Account';
      this.clickedBtn = 'account';
    } else if (
      this.router.url == '/system-setting/account-management/basicinfo' ||
      this.router.url == '/system-setting/account-management/products' ||
      this.router.url == '/system-setting/account-management/receipts' ||
      this.router.url == '/system-setting/account-management/payment'
    ) {
      this.ForDataBind = 'Account Management';
      this.clickedBtn = 'account-management';
    } else if (this.router.url == '/system-setting/interest-rates') {
      this.clickedBtn = 'interest-rates';
      this.ForDataBind = 'Interest Rates';
    } else if (this.router.url == '/system-setting/exchange-rates') {
      this.clickedBtn = 'exchange-rates';
      this.ForDataBind = 'Exchange Rates';
    } else if (this.router.url == '/system-setting/matter-class-rates') {
      this.clickedBtn = 'matterRate';
      this.ForDataBind = 'Matter Class Rates';
    } else if (this.router.url == '/system-setting/search-provider') {
      this.clickedBtn = 'searchProvider';
      this.ForDataBind = 'Searching Settings';
    } else if (this.router.url == '/system-setting/aml-ctf') {
      this.ForDataBind = 'AML/CTF Settings';
      this.clickedBtn = 'aml-ctf';
    } else if (this.router.url == '/system-setting/xero-integration') {
      this.clickedBtn = 'xeroIntegration';
      this.ForDataBind = 'Xero Integration Settings';
    } else if (this.router.url == '/system-setting/SilqPay') {
      this.clickedBtn = 'SilqPay';
      this.ForDataBind = 'SILQ Pay Settings';
    } else if (this.router.url == '/system-setting/statements') {
      this.clickedBtn = 'statements';
      this.ForDataBind = 'Statement Settings';
    } else if (this.router.url == '/system-setting/lookups') {
      this.clickedBtn = 'lookups';
      this.ForDataBind = 'Lookups';
    } else if (this.router.url == '/system-setting/miscellaneous') {
      this.clickedBtn = 'miscellaneous';
      this.ForDataBind = 'Miscellaneous';
    } else if (this.router.url == '/system-setting/email-signature') {
      this.clickedBtn = 'email-signature';
      this.ForDataBind = 'Email Signature';
    } else if (this.router.url == '/system-setting/email-configuration') {
      this.clickedBtn = 'email-configuration';
      this.ForDataBind = 'Email Configuration';
    } else if (this.router.url == '/system-setting/invoice-options') {
      this.clickedBtn = 'invoice-options';
      this.ForDataBind = 'Invoice Options Template';
    } else if (this.router.url == '/system-setting/activities') {
      this.clickedBtn = 'activities';
      this.ForDataBind = 'Activities & Sundries';
    } else if (this.router.url == '/system-setting/apiaccess') {
      this.clickedBtn = 'api-access';
      this.ForDataBind = 'API Access';
    } else if (this.router.url == '/system-setting/users') {
      this.clickedBtn = 'users';
      this.ForDataBind = 'Users';
    } else if (this.router.url == '/system-setting/users/useractivity') {
      this.clickedBtn = 'userActivity';
      this.ForDataBind = 'User Activity';
    } else if (this.router.url == '/system-setting/workflow') {
      this.clickedBtn = 'workflow';
      this.ForDataBind = 'Workflow';
    }
  }
  loading_fun() {
    this.isLoadingResults = true;
    this.behaviorService.loadingSystemSetting(null);
    this.behaviorService.loadingSystemSetting$
      .pipe(takeUntil(this._unsubscribeAll$))
      .subscribe((result: any) => {
        if (result) {
          this.isLoadingResults = false;
          this.cd.detectChanges();
        }
      });
  }

  chnageUrlFunction(btn: any, data: any) {
    this.clickedBtn = btn;
    this.ForDataBind = data;
  }
  get f() {
    return this.SettingForm.controls;
  }

  save() {
    this.isspiner = true;
    this.cd.markForCheck();
    let tempArrayAccountGroup: any = {};
    this.SetAccountArray = [];
    let data = {
      //for name
      BARRISTERSNAME: this.f.BARRISTERSNAME.value,
      ADDRESSGROUP: {
        STREETADDRESSGROUP: {
          ADDRESS1: this.f.ADDRESS1.value,
          ADDRESS2: this.f.ADDRESS2.value,
          SUBURB: this.f.SUBURB.value,
          STATE_: this.f.STATE.value,
          POSTCODE: this.f.POSTCODE.value,
        },
        POSTALADDRESSGROUP: {
          POSTALADDRESS1: this.f.POSTALADDRESS1.value,
          POSTALADDRESS2: this.f.POSTALADDRESS2.value,
          POSTALSUBURB: this.f.POSTALSUBURB.value,
          POSTALSTATE: this.f.POSTALSTATE.value,
          POSTALPOSTCODE: this.f.POSTALPOSTCODE.value,
        },
        DXGROUP: {
          DXNUMBER: this.f.DXNUMBER.value,
          DXSUBURB: this.f.DXSUBURB.value,
        },
      },
      CONTACTGROUP: {
        PHONE1: this.f.PHONE1.value,
        PHONE2: this.f.PHONE2.value,
        FAX1: this.f.FAX1.value,
        FAX2: this.f.FAX2.value,
        EMAIL: this.f.EMAIL.value,
        WWW: this.f.WWW.value,
      },
      BUSINESSGROUP: {
        // ABN: this.f.ABN.value,
        ABN: this.f.ABN.value,
        FAMILYLAWCOURTID: this.f.FAMILYLAWCOURTID.value,
        LRSBOXNUMBER: this.f.LRSBOXNUMBER.value,
        GSTTYPE: this.f.GSTTYPE.value,
        HOURLYBASERATE: this.f.HOURLYBASERATE.value,
        DAILYBASERATE: this.f.DAILYBASERATE.value,
        HOURLYBASERATE2: this.f.HOURLYBASERATE2.value,
        DAILYBASERATE2: this.f.DAILYBASERATE2.value,
        HOURLYBASERATE3: this.f.HOURLYBASERATE3.value,
        DAILYBASERATE3: this.f.DAILYBASERATE3.value,
        HOURLYBASERATE4: this.f.HOURLYBASERATE4.value,
        DAILYBASERATE4: this.f.DAILYBASERATE4.value,
        HOURLYBASERATE5: this.f.HOURLYBASERATE5.value,
        DAILYBASERATE5: this.f.DAILYBASERATE5.value,
        HOURLYBASERATE6: this.f.HOURLYBASERATE6.value,
        DAILYBASERATE6: this.f.DAILYBASERATE6.value,
        OFFICECHEQUEFORMAT: this.f.OFFICECHEQUEFORMAT.value,
        VENDORISLIABLEFORSETTLEMENTDATE: this.f.VENDORISLIABLEFORSETTLEMENTDATE.value,
        USESINGLELINEEXPENSE: this.f.USESINGLELINEEXPENSE.value,
        RATEOVERRIDESEQUENCE: this.f.RATEOVERRIDESEQUENCE.value,
        DEFAULTEXPENSETYPE: this.f.DEFAULTEXPENSETYPE.value,
        DEFAULTPAIDTYPE: this.f.DEFAULTPAIDTYPE.value,
        DEFAULTINCOMETYPE: this.f.DEFAULTINCOMETYPE.value,
        SHORTNAMESTRATEGY: this.f.SHORTNAMESTRATEGY.value,
        REQUIRECOSTAGREEMENT: this.f.REQUIRECOSTAGREEMENT.value,
        DEFAULTMATTERCLASS: this.f.DEFAULTMATTERCLASS.value,
        REQUIREMATTEROWNER: this.f.REQUIREMATTEROWNER.value,
        REQUIREFEEEARNER: this.f.REQUIREFEEEARNER.value,
        SUNDRYFEEEARNER: this.f.SUNDRYFEEEARNER.value,
        SHOWCONFLICTCHECKFORNEWMATTER: this.f.SHOWCONFLICTCHECKFORNEWMATTER.value,
        CHARGEDISBGSTONGSTFREEMATTERS: this.f.CHARGEDISBGSTONGSTFREEMATTERS.value,
        ALLOWMOBILEACCESS: this.f.ALLOWMOBILEACCESS.value,
        DONTALLOWTRUSTOVERDRAWS: this.f.DONTALLOWTRUSTOVERDRAWS.value,
        ESTIMATEWARNINGPERCENT: this.f.ESTIMATEWARNINGPERCENT.value,
        ESTIMATENEXTTHRESHOLD: this.f.ESTIMATENEXTTHRESHOLD.value,
        ESTIMATENEXTWARNINGPERCENT: this.f.ESTIMATENEXTWARNINGPERCENT.value,
        ALLOWESTIMATERANGE: this.f.ALLOWESTIMATERANGE.value,
        USEHIGHESTIMATEFORWARNING: this.f.USEHIGHESTIMATEFORWARNING.value,
        FIRSTTRUSTMONTH: this.f.FIRSTTRUSTMONTH.value,
        DELIVERABLES: this.f.MATTERDELIVERABLEGUID.value,
        REQUIREMATTERTYPE: this.f.REQUIREMATTERTYPE.value,
        REQUIRECLIENTSOURCE: this.f.REQUIRECLIENTSOURCE.value,
        REQUIREFIELDOFLAW: this.f.REQUIREFIELDOFLAW.value,
        REQUIREEXPENSEPAYEE: this.f.REQUIREEXPENSEPAYEE.value,
        RATEDESCRIPTION1: this.f.RATEDESCRIPTION1.value,
        RATEDESCRIPTION2: this.f.RATEDESCRIPTION2.value,
        RATEDESCRIPTION3: this.f.RATEDESCRIPTION3.value,
        RATEDESCRIPTION4: this.f.RATEDESCRIPTION4.value,
        RATEDESCRIPTION5: this.f.RATEDESCRIPTION5.value,
        RATEDESCRIPTION6: this.f.RATEDESCRIPTION6.value,
      },
      FEEEARNERS: {
        UNITSPERHOUR: this.f.UNITSPERHOUR.value,
      },
      INVOICEDEFAULTS: {
        DUEDATEOFFSET: this.f.DUEDATEOFFSET.value,
        INVOICETEMPLATE: this.f.INVOICETEMPLATE.value,
        INVOICESAVEFOLDERLOCATION: this.f.INVOICESAVEFOLDERLOCATION.value,
        RECEIPTSAVEFOLDERLOCATION: this.f.RECEIPTSAVEFOLDERLOCATION.value,
        INVOICESAVEFOLDERPARENT: this.f.INVOICESAVEFOLDERPARENT.value,
        RECEIPTSAVEFOLDERPARENT: this.f.RECEIPTSAVEFOLDERPARENT.value,
        RECEIPTTEMPLATE: this.f.RECEIPTTEMPLATE.value,
        DONTGENERATERECEIPT: this.f.DONTGENERATERECEIPT.value,
        // DEFAULTSUBFOLDERS: this.f.DEFAULTSUBFOLDERS.value,
      },
      REGIONALGROUP: {
        COUNTRY: this.f.COUNTRY.value,
        TAXTYPE: this.f.TAXTYPE.value,
        TAXRATE: this.f.TAXRATE.value,
        CURRENCYSYMBOL: this.f.CURRENCYSYMBOL.value,
        TIMEZONE: this.f.TIMEZONE.value,
      },
      TRUSTGROUP: {
        TRUSTSTATE: this.f.TRUSTSTATE.value,
        TRUSTCHEQUEFORMAT: this.f.TRUSTCHEQUEFORMAT.value,
        TRUSTRECEIPTCOPIES: this.f.TRUSTRECEIPTCOPIES.value,
        EFTTRUSTACCOUNTNAME: this.f.EFTTRUSTACCOUNTNAME.value,
        EFTTRUSTBSB: this.f.EFTTRUSTBSB.value,
        EFTTRUSTACCOUNTNUMBER: this.f.EFTTRUSTACCOUNTNUMBER.value,
        DEFAULTTRUSTRECEIPTTYPE: this.f.DEFAULTTRUSTRECEIPTTYPE.value,
        DEFAULTTRUSTWITHDRAWALTYPE: this.f.DEFAULTTRUSTWITHDRAWALTYPE.value,
        TRUSTACCACCOUNTNAME: this.f.TRUSTACCACCOUNTNAME.value,
        TRUSTACCBSB: this.f.TRUSTACCBSB.value,
        TRUSTACCACCOUNTNUMBER: this.f.TRUSTACCACCOUNTNUMBER.value,
        TRUSTFIRSTWITHDRAWALCODE: this.f.TRUSTFIRSTWITHDRAWALCODE.value,
        TRUSTFIRSTWITHDRAWALEFTID: this.f.TRUSTFIRSTWITHDRAWALEFTID.value,
        TRUSTFIRSTTRANSFERCODE: this.f.TRUSTFIRSTTRANSFERCODE.value,
        TRUSTFIRSTRECEIPTCODE: this.f.TRUSTFIRSTRECEIPTCODE.value,
      },
      DOCUMENTGROUP: {
        DOCUMENTSYSTEM: this.f.DOCUMENTSYSTEM.value,
        SHAREPOINTSITE: this.f.SHAREPOINTSITE.value,
        SHAREPOINTSUBSITE: this.f.SHAREPOINTSUBSITE.value,
        ROOTFOLDER: this.f.ROOTFOLDER.value,
        SHAREPOINTDRIVE: this.f.SHAREPOINTDRIVE.value,
        // TEMPLATEFOLDER: this.f.TEMPLATEFOLDER.value,
        DIRECTORYSAVESTRATEGY: this.f.DIRECTORYSAVESTRATEGY.value,
        DOCUMENTSAVESTRATEGY: this.f.DOCUMENTSAVESTRATEGY.value,
        TRACKDOCUMENTS: this.f.TRACKDOCUMENTS.value,
        ONEDRIVEPRIMARYUSER: this.f.ONEDRIVEPRIMARYUSER.value,
        DEFAULTSUBFOLDERS: this.f.DEFAULTSUBFOLDERS.value,
        NETDOCSCABINETNAME: this.f.NETDOCSCABINETNAME.value,
        NETDOCSCLIENTATTRIBUTE: this.f.NETDOCSCLIENTATTRIBUTE.value,
        NETDOCSMATTERATTRIBUTE: this.f.NETDOCSMATTERATTRIBUTE.value,
        //statment setting
        STATEMENT2: this.f.STATEMENT2.value,
        STATEMENT3: this.f.STATEMENT3.value,
        STATEMENT4: this.f.STATEMENT4.value,
        STATEMENT5: this.f.STATEMENT5.value,
        STATEMENT2RTFBASEB4: this.f.STATEMENT2RTFBASE64.value,
        STATEMENT3RTFBASEB4: this.f.STATEMENT3RTFBASE64.value,
        STATEMENT4RTFBASEB4: this.f.STATEMENT4RTFBASE64.value,
        STATEMENT2RTFFILE: this.f.STATEMENT2RTFFILE.value,
        STATEMENT3RTFFILE: this.f.STATEMENT3RTFFILE.value,
        STATEMENT4RTFFILE: this.f.STATEMENT4RTFFILE.value,

        STATEMENT2ISRTF: this.f.STATEMENT2ISRTF.value,
        STATEMENT3ISRTF: this.f.STATEMENT3ISRTF.value,
        STATEMENT4ISRTF: this.f.STATEMENT4ISRTF.value,
        FEEAGREEMENTSTATEMENT: this.f.FEEAGREEMENTSTATEMENT.value,
      },
      XEROGROUP: {
        XEROINVOICEACCOUNT: this.f.XEROINVOICEACCOUNT.value,
        XERODONTSYNCEXPENSES: this.f.XERODONTSYNCEXPENSES.value == true ? 1 : 0,
        XERODONTSYNCINVOICES: this.f.XERODONTSYNCINVOICES.value == true ? 1 : 0,
        XEROORGANISATION: this.f.XEROORGANISATION.value,
        XEROSTARTDATE: this.f.XEROSTARTDATE.value,
      },
      SEARCHINGGROUP: {
        SEARCHPROVIDER: this.f.SEARCHPROVIDER.value,
        SEARCHUSERNAME: this.f.SEARCHUSERNAME.value,
        SEARCHPASSWORD: this.f.SEARCHPASSWORD.value,
        SEARCHGSTHANDLING: this.f.SEARCHGSTHANDLING.value,
        SEARCHURL: this.f.SEARCHURL.value,
        SEARCHDOWNLOADUSERGUID: this.f.SEARCHDOWNLOADUSERGUID.value,
      },
      SILQPAYGROUP: {
        PINPAYMENTSAPIKEY: this.f.PINPAYMENTSAPIKEY.value,
        PINPAYMENTSABSORBFEE: this.f.PINPAYMENTSABSORBFEE.value,
        SILQPAYLINKDESC: this.f.SILQPAYLINKDESC.value,
        SILQPAYSHOWINVDETAILS: this.f.SILQPAYSHOWINVDETAILS.value,
        SILQPAYSHOWCHEQUEPAYMENT: this.f.SILQPAYSHOWCHEQUEPAYMENT.value,
        SILQPAYSHOWDDPAYMENT: this.f.SILQPAYSHOWDDPAYMENT.value,
        SILQPAYSHOWINVOICESTATEMENT1: this.f.SILQPAYSHOWINVOICESTATEMENT1.value,
        SILQPAYSHOWINVOICESTATEMENT2: this.f.SILQPAYSHOWINVOICESTATEMENT2.value,
        SILQPAYSHOWINVOICESTATEMENT3: this.f.SILQPAYSHOWINVOICESTATEMENT3.value,
        SILQPAYSHOWFEEAGRSTATEMENT: this.f.SILQPAYSHOWFEEAGRSTATEMENT.value,
        SILQPAYSHOWGLOBALFOOTER: this.f.SILQPAYSHOWGLOBALFOOTER.value,
      },
      APLYIDKEY: this.f.APLYIDKEY.value,
      APLYIDSECRET: this.f.APLYIDSECRET.value,
      ACCOUNTSGROUP: {},
    };
    this.accountDialoge.forEach((element: any) => {
      let key = element.ACCOUNTGUIDNAME;
      let val = element.ACCOUNTGUID;
      tempArrayAccountGroup[key] = val;
    });
    if (this.currentUSer?.PRODUCTTYPE == 'Barrister') {
      data['CHAMBERS'] = this.f.CHAMBERS.value;
    }
    data['ACCOUNTSGROUP'] = tempArrayAccountGroup;
    // data.ACCOUNTSGROUP.push(this.SetAccountArray)

    const payload = { Action: 'Update', VALIDATEONLY: true, Data: data };
    this._mainAPiServiceService
      .getSetData(payload, 'system')
      .pipe(takeUntil(this._unsubscribeAll$))
      .subscribe({
        next: (response: any) => {
          if (response.CODE == 200 && (response.STATUS == 'OK' || response.STATUS == 'success')) {
            this.checkValidation(response.DATA.VALIDATIONS, payload);
            this.behaviorService.DELIVERABLES$.next(
              localStorage.getItem('set_active_DELIVERABLES'),
            );
          } else if (
            (response.CODE == 451 || response.CODE == 450) &&
            response.STATUS == 'warning'
          ) {
            this.checkValidation(response.DATA.VALIDATIONS, payload);
          } else if ((response.CODE == 450 || response.CODE == 451) && response.STATUS == 'error') {
            this.checkValidation(response.DATA.VALIDATIONS, payload);
          }
          this.cd.markForCheck();
        },
        error: (error: any) => {
          this.isspiner = false;
          this.toastr.error(error);
          this.cd.markForCheck();
        },
      });
  }

  checkValidation(bodyData: any, data1: any, ApiName?: any) {
    this.isspiner = true;
    let errorData: any = [];
    let warningData: any = [];
    let tempError: any = [];
    let tempWarning: any = [];
    bodyData?.forEach((value: { VALUEVALID: string; ERRORDESCRIPTION: any; FIELDNAME: any }) => {
      if (value.VALUEVALID == 'No' || value.VALUEVALID == 'no') {
        errorData.push(value.ERRORDESCRIPTION);
        tempError[value.FIELDNAME] = value;
      } else if (value.VALUEVALID == 'Warning' || value.VALUEVALID == 'warning') {
        tempWarning[value.FIELDNAME] = value;
        warningData.push(value.ERRORDESCRIPTION);
      }
    });
    this.errorWarningData = { Error: tempError, warning: tempWarning };
    if (Object.keys(errorData).length != 0) {
      this.isspiner = false;
      this.toastr.error(errorData);
      this.cd.markForCheck();
    } else if (Object.keys(warningData).length != 0) {
      this.isspiner = false;
      this.confirmDialogRef = this._matDialog.open(FuseConfirmDialogComponent, {
        disableClose: true,
        width: DIALOG_WIDTH.FULL,
        data: warningData,
      });
      this.confirmDialogRef.componentInstance.confirmMessage = 'Are you sure you want to Save?';
      this.confirmDialogRef.afterClosed().subscribe((result: any) => {
        if (result) {
          this.isspiner = true;
          this.saveSettingData(data1);
        }
        this.confirmDialogRef = null;
        this.cd.markForCheck();
      });
      this.cd.markForCheck();
    } else if (Object.keys(warningData).length == 0 && Object.keys(errorData).length == 0) {
      this.saveSettingData(data1);
    } else if (Object.keys(warningData).length != 0) {
      localStorage.setItem('confEWshow', 'warning');
      this.confirmDialogRef = this._matDialog.open(FuseConfirmDialogComponent, {
        disableClose: true,
        width: DIALOG_WIDTH.FULL,
        data: warningData,
      });
      this.confirmDialogRef.componentInstance.confirmMessage =
        ApiName === 'SetInvoice' ? '' : warningData;
      this.confirmDialogRef.afterClosed().subscribe((result: any) => {
        localStorage.removeItem('confEWshow');
        if (result) {
          this.DeleteGData(data1, ApiName);
        }
        this.confirmDialogRef = null;
        this.cd.markForCheck();
      });
      this.cd.markForCheck();
    } else if (Object.keys(warningData).length == 0 && Object.keys(errorData).length == 0) {
      this.DeleteGData(data1, ApiName);
    }
  }

  DeleteGData(data: any, ApiName: any) {
    data.VALIDATEONLY = false;
    this._mainAPiServiceService.getSetData(data, ApiName).subscribe({
      next: (response: any) => {
        if (response.CODE == 200 && (response.STATUS == 'OK' || response.STATUS == 'success')) {
          this.toastr.success('Deleted successfully');
          $('#refreshInvoiceTab').click();
          $('#refreshMatterInvoice').click();
        } else if (response.CODE == 451 && response.STATUS == 'warning') {
          this.toastr.warning(response.MESSAGE);
        } else if (response.CODE == 450 && response.STATUS == 'error') {
          this.toastr.error(response.MESSAGE);
        } else if (response.MESSAGE == 'Not logged in') {
          this.dialogRef.close(false);
        }
        this.cd.markForCheck();
      },
      error: (error: any) => {
        this.toastr.error(error);
        this.cd.markForCheck();
      },
    });
  }
  saveSettingData(data1: any) {
    this.isspiner = true;
    data1.VALIDATEONLY = false;
    this._mainAPiServiceService
      .getSetData(data1, 'system')
      .pipe(
        takeUntil(this._unsubscribeAll$),
        switchMap((response) =>
          combineLatest([of(response), this.loadSharePointSubsites(response)]),
        ),
      )
      .subscribe({
        next: ([response]: any) => {
          if (response.CODE == 200 && (response.STATUS == 'OK' || response.STATUS == 'success')) {
            this.currentUSer['ALLOWESTIMATERANGE'] = this.f.ALLOWESTIMATERANGE.value;
            this.currentUSer['USEHIGHESTIMATEFORWARNING'] = this.f.USEHIGHESTIMATEFORWARNING.value;
            this.currentUSer['SHOWCONFLICTCHECKFORNEWMATTER'] =
              this.f.SHOWCONFLICTCHECKFORNEWMATTER.value;
            this.currentUSer['CHARGEDISBGSTONGSTFREEMATTERS'] =
              this.f.CHARGEDISBGSTONGSTFREEMATTERS.value;
            this.currentUSer['DEFAULTMATTERCLASS'] = this.f.DEFAULTMATTERCLASS.value;
            this.currentUSer['DISBURSEMENTACCOUNTGUID'] =
              data1.Data.ACCOUNTSGROUP.DISBURSEMENTACCOUNT;

            localStorage.setItem('currentUser', JSON.stringify(this.currentUSer));
            this.toastr.success('Updated successfully');
            this.isspiner = false;
          } else if (response.CODE == 451 && response.STATUS == 'warning') {
            this.isspiner = false;
            this.toastr.warning(response.MESSAGE);
          } else if (response.CODE == 450 && response.STATUS == 'error') {
            this.isspiner = false;
            this.toastr.error(response.MESSAGE);
          } else {
            this.isspiner = false;
          }
          this.cd.markForCheck();
        },
        error: (error: any) => {
          this.isspiner = false;
          this.toastr.error(error);
          this.cd.markForCheck();
        },
      });
  }

  /**
   * Starts a system-settings save, then refreshes SharePoint subsites after that save succeeds.
   * @param event Truthy when the templates tab asks to save.
   */
  systemSettingRef(event: any) {
    if (event) {
      this.save();
    }
  }

  commonFocusWindow(url: any, modul: any) {
    const active_matter = JSON.parse(localStorage.getItem('set_active_matters'));
    let random: any = active_matter;
    // random = window.open(url, modul);
    this.router.navigate([url]);
    random.focus();
  }
  targetNewTab(URL: any, modul: string) {
    const currentUser = JSON.parse(localStorage.getItem('currentUser'));
    if (currentUser && currentUser.OPENINNEWTAB) {
      const url = this.router.serializeUrl(this.router.createUrlTree([URL]));
      let target;
      this.router.navigate([URL]);
      // if (/[,\-|\/]/.test(URL)) {
      //     target = URL.replace(/-|\//g, "");
      // } else {
      //     target = URL;
      // }
      // if (environment.ISPRO) {
      //     // window.open
      //     this.commonFocusWindow(url, target);
      // } else {
      //     // window.open
      //     this.commonFocusWindow('/' + environment.URLPATH + '/#' + url, target);
      // }
    } else {
      setTimeout(() => {
        this.router.navigate([URL]);
      }, 100);
    }
  }

  ActivitySundryDialog(actionType: any) {
    this.SetOldistrackid('open');
    let popupData: any = {};
    if (actionType == 'new') {
      popupData = { action: actionType };
    } else if (actionType == 'edit' || actionType == 'Duplicate') {
      let ActivityData = JSON.parse(localStorage.getItem('current_ActivityData'));
      if (!ActivityData) {
        this.toastr.error('Please Select Activity');
        return false;
      }
      popupData = {
        action: actionType,
        ACTIVITYGUID: ActivityData.ACTIVITYGUID,
      };
    }
    const dialogRef = this._matDialog.open(ActivitySundryDialogComponent, {
      disableClose: true,
      panelClass: 'Activity-dialog',
      data: popupData,
    });
    dialogRef.afterClosed().subscribe((result: any) => {
      this.SetOldistrackid('close');
      if (result) {
        $('#refreshActivities').click();
      }
      this.cd.markForCheck();
    });
  }

  DeleteActivityDialog(): void {
    this.confirmDialogRef = this._matDialog.open(FuseConfirmDialogComponent, {
      disableClose: true,
      width: DIALOG_WIDTH.FULL,
    });
    this.confirmDialogRef.componentInstance.confirmMessage = 'Are you sure you want to delete?';
    this.confirmDialogRef.afterClosed().subscribe((result: any) => {
      if (result) {
        let ActivityData = JSON.parse(localStorage.getItem('current_ActivityData'));
        let postData = {
          ACTION: 'delete',
          DATA: { ACTIVITYGUID: ActivityData.ACTIVITYGUID },
        };
        let RefreshIdArray: any = ['#refreshActivities'];
        this.SetVariableForRetry(postData, 'activity', RefreshIdArray);
        this._mainAPiServiceService.getSetData(postData, 'activity').subscribe({
          next: (res: any) => {
            if (res.STATUS == 'success' && res.CODE == 200) {
              localStorage.setItem('istrackid', this.oldIsTrackId);
              $('#refreshActivities').click();
              this.toastr.success('Deleted successfully');
            } else if (res.CODE == 451 && res.STATUS == 'warning') {
              this.checkValidation(res.DATA.VALIDATIONS, postData, 'activity');
            } else if (res.CODE == 450 && res.STATUS == 'error') {
              this.checkValidation(res.DATA.VALIDATIONS, postData, 'activity');
            } else if (res.MESSAGE == 'Not logged in') {
              this.dialogRef.close(false);
            }
            this.cd.markForCheck();
          },
          error: (error: any) => {
            this.toastr.error(error);
            this.cd.markForCheck();
          },
        });
      }
      this.confirmDialogRef = null;
      this.cd.markForCheck();
    });
  }

  SetVariableForRetry(PostData: any, Methode: any, RefreshArray: any) {
    this.oldIsTrackId = localStorage.getItem('istrackid');
    this.DeletePostData = PostData;
    this.ApiMethod = Methode;
    this.refreshId = RefreshArray;
    localStorage.setItem('istrackid', 'DeleteDataClick');
  }

  SetOldistrackid(type: any) {
    if (type === 'open') {
      this.oldIsTrackId = localStorage.getItem('istrackid');
    } else {
      localStorage.setItem('istrackid', this.oldIsTrackId);
    }
  }

  GetChildData(data: any) {
    // this.Deliverabledata=data
    localStorage.setItem('set_active_DELIVERABLES', data);
  }

  addActivities(event: any) {
    this.ActivitySundryDialog('new');
  }

  addDuplicateActivities(event: any) {
    this.ActivitySundryDialog('Duplicate');
  }

  /**
   * Loads SharePoint subsites for the active matter after a successful system save.
   * @param res Save response stored on the systemSettingRefresh$ signal.
   * @returns The cloud-storage response, or an empty array when the save did not succeed.
   */
  private loadSharePointSubsites(res: any) {
    const saved = res?.CODE === 200 && (res.STATUS === 'OK' || res.STATUS === 'success');
    if (!saved) {
      return of([]);
    }
    const matter = JSON.parse(localStorage.getItem('set_active_matters'));
    const payload = {
      Action: 'NetDriveGetDocument',
      Data: {
        FILETYPE: 'SUBSITES',
        MATTERGUID: matter.MATTERGUID,
      },
    };
    return this._mainAPiServiceService
      .getSetData(payload, 'cloud-storage')
      .pipe(catchError(() => of([])));
  }
}
